import { ListPortraitsResponse } from "tng-address-collection-shared/types/portraitsApiTypes.ts";

export type Employee = ListPortraitsResponse["employees"][number];

export const FILTERS = {
  chosen: (employee: Employee) => employee.portrait?.choice !== undefined,
  flagged: (employee: Employee) => employee.portrait?.flagged === true,
  notChosenYet: (employee: Employee) => employee.portrait?.choice === undefined,
};
export type Filter = keyof typeof FILTERS;

export type ColleagueNavigation = {
  previous?: number;
  next?: number;
  /** Counted among those the filter shows, so missing once the colleague drops out */
  position?: number;
  count: number;
};

/** Goes by the whole list, so a colleague who no longer matches still has neighbours */
export const navigationAround = (
  employees: Employee[],
  filter: Filter,
  uidNumber: number,
): ColleagueNavigation => {
  const matches = FILTERS[filter];
  const index = employees.findIndex(
    (employee) => employee.uidNumber === uidNumber,
  );
  const matching = employees.filter(matches);
  const position = matching.findIndex(
    (employee) => employee.uidNumber === uidNumber,
  );

  return {
    previous:
      index < 0
        ? undefined
        : employees.slice(0, index).findLast(matches)?.uidNumber,
    next:
      index < 0
        ? undefined
        : employees.slice(index + 1).find(matches)?.uidNumber,
    position: position < 0 ? undefined : position + 1,
    count: matching.length,
  };
};
